import { createIcon } from "@chakra-ui/icons";

// Source: https://fontawesome.com/icons/smoke?s=solid
export default createIcon({
  displayName: "Smoke",
  viewBox: "0 0 640 512",
  path: (
    <path
      d="M144 192c9.875 0 19.5 .875 29.12 2.5C197.3 136.8 253.8 96 320 96c26.25 0 52 6.75 75.13 19.25c9.25-10.25 20.12-18.5 31.62-25.88C403.8 54.88 364.6 32 320 32C288.4 32 259.9 43.88 237.6 62.75C215.3 25.25 174.8 0 128 0C57.25 0 0 57.25 0 128c0 38.25 17.12 72.13 43.75 95.63C72.25 203.8 106.8 192 144 192zM402.4 158.8C380.1 139.9 351.6 128 320 128C268.3 128 224.1 158.8 203.9 202.8C219.5 208.5 234.5 216.3 248 226.3C277.1 204 313.1 192 352 192c54.88 0 105.1 25.88 139 69.13C503.1 257.8 515.5 256 528 256c35.5 0 67.63 13.38 92.75 34.75C632.8 271.3 640 248.6 640 224c0-70.75-57.25-128-128-128C465.3 96 424.8 121.3 402.4 158.8zM528 288c-18 0-34.75 4.625-49.75 12.12C453.1 254.1 406.8 224 352 224C311 224 274.3 241.3 248 268.8C221.8 241.3 185 224 144 224C64.5 224 0 288.5 0 368S64.5 512 144 512h384c61.88 0 112-50.13 112-112S589.9 288 528 288z"
      fill="currentColor"
    />
  ),
});
